module.exports = __webpack_public_path__ + "img/LENNOX.f9883878.png";